import profile from 'iztech-design-system-neo/dist/system/i18n/en/profile'

export default {
  ...profile,
	MSG_DATA_VALIDATOR: 'Please re-check information!',
	MSG_INVALID_SIGNED_USER: "You haven't signed in yet. Please sign in first!",
	MSG_UPDATE_FAIL: 'Update fail!',
	MSG_UPDATE_SUCCESS: 'Update successfully!',
}